import MenuBarComponent from 'app/components/MenuBarComponent/MenuBarComponent';
import InformationCard from 'app/components/InformationCard/InformationCard';
import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import './Dashboard.scss';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'app/redux/store';
import { getLenderSummaryHeaderAction } from 'app/redux/actions/PortofolioAction';
import rupiahCurrencyFormatter from 'app/utils/RupiahPipe';
import { IMenuList } from 'app/interfaces/menu-bar/menuBar.interface';
import ROUTER_PATH from 'app/routes/routerPath';
import LocalStorageService from 'app/services/localStorage';
import ImagePath from 'app/utilities/imagePath';
import { USER_TYPE } from 'constants/userType';
import { getTkbAction, getWidgetProgressAction } from 'app/redux/actions/NavHeaderAction';
import WidgetProcessBulkFunding from 'app/components/WidgetProcessBulkFunding/WidgetProcessBulkFunding';
import { LenderSummaryHeaderInterface } from '../../interfaces/lender/LenderSummaryHeaderInterface';
import { getCoorporateProfile } from '../../redux/actions/CorporateProfileAction';

const Dashboard = function init(): React.ReactElement {
    const menuList: IMenuList[] = [
        {
            title: 'Portofolio',
            path: ROUTER_PATH.portofolio
        },
		{
            title: 'User Portofolio',
            path: ROUTER_PATH.userPortofolio
        },
		{
            title: 'Transaction History',
            path: ROUTER_PATH.transactionHistory
        },
    ];
	const lenderSummaryState: LenderSummaryHeaderInterface = {
		lenderId: '',
		cashBalance: 0,
		outStandingBalance: 0,
		estTotalGet: 0,
		estInterestGet: 0,
		additionalCashBalance: 0
	};
	const dispatch = useDispatch();
	const portofolioState = useSelector((state: RootState) => state.portofolioReducer);
	const { lenderSummary, summaryLoading } = portofolioState;
	const [summary, setSummary] = useState(lenderSummaryState);
	const [summaryTextLabel, setSummaryTextLable] = useState({ data: [{ title: '', value: '' }] });
	const user = LocalStorageService.getUserData();
	const navHeaderData = useSelector((state: RootState) => state.navHeaderReducer);
	const widgetData = navHeaderData?.widgetProgressAction;

	useEffect(() => {
		dispatch(getLenderSummaryHeaderAction());
		dispatch(getTkbAction());
		dispatch(getWidgetProgressAction());
		if (user.userTypeId === USER_TYPE.LENDER_INSTITUTIONAL) {
			dispatch(getCoorporateProfile());
		}
	}, []);

	useEffect(() => {
		setSummary(lenderSummary);
	}, [lenderSummary]);

	useEffect(() => {
		if (summary) {
			const sum = { data: [
				{
					logo: ImagePath.outstandingAmount,
					title: 'Outstanding Balance',
					value: rupiahCurrencyFormatter(summary.outStandingBalance)
				},
				{
					logo: ImagePath.chartLine,
					title: 'Perkiraan Total Pendapatan',
					value: rupiahCurrencyFormatter(summary.estTotalGet)
				},
				{
					logo: ImagePath.interest,
					title: 'Perkiraan Bunga pendapatan',
					value: rupiahCurrencyFormatter(summary.estInterestGet)
				},
			] };
			setSummaryTextLable(sum);
		}
	}, [summary]);

    return (
        <div className="dashboard-layout">
			<div style={{ display: 'flex' }}>
				<div style={{ flex: 1, marginRight: '20px' }}>
					<InformationCard data={summaryTextLabel.data} loading={summaryLoading} />
				</div>
				{widgetData?.data?.isShowWidgetProcess && (
					<div style={{ flex: 1 }}>
						<WidgetProcessBulkFunding />
					</div>
				)}
			</div>
            <MenuBarComponent
				menuList={menuList}
				loading={summaryLoading}
            />
			<Outlet />
        </div>
    );
};

export default Dashboard;
